module.exports = __webpack_public_path__ + "img/onboarding-calendar-nikon-it.9a8becc8.png";